import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";
import { MillSizeSelector } from "./MillSizeSelector";

interface CartridgesToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	millSizeId: number | null;
	onMillSizeChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const CartridgesToolbar = ({
	search,
	onSearchChange,
	millSizeId,
	onMillSizeChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: CartridgesToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
				p: 1,
				backgroundColor: "background.paper",
				borderRadius: 1,
			}}
		>
			<TextField
				size="small"
				placeholder="Search cartridges..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<MillSizeSelector
				value={millSizeId}
				onChange={onMillSizeChange}
				includeAll
				size="small"
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
				sx={{ whiteSpace: "nowrap" }}
			>
				Add Cartridge
			</Button>
		</Box>
	);
};
